import { graphql } from '@/generated/gql';

export const SOURCING_CASE_RESUBMIT_MUTATION = graphql(/* GraphQL */ `
  mutation TesseractSourcingCaseResubmit($id: UUID!) {
    tesseract {
      sourcingCase(id: $id) {
        resubmit
      }
    }
  }
`);
